
import { computed, onBeforeMount, ref, defineComponent, watch, ComputedRef } from "vue";
import { useStore } from "vuex";
import Moldure from "../infrastructure/presentation/components/application/moldure/Moldure.vue";
import ErrorBox from "../infrastructure/presentation/components/application/ErrorBox.vue";
import SuccessBox from "../infrastructure/presentation/components/application/SuccessBox.vue";
import AlertBox from "../infrastructure/presentation/components/application/AlertBox.vue";
import Loading from "../infrastructure/presentation/components/application/shop/Loading.vue";
import { isCirculoTemplate } from "../infrastructure/presentation/components/mixins";
import DecoinsLimitModal from "../infrastructure/presentation/components/application/modals/DecoinsLimitModal.vue";
import { createClarityScript } from "../infrastructure/repository/scripts/clarity";
import { Ref } from "vue";
import IndicationUsersModal from "../infrastructure/presentation/components/application/modals/IndicationUsersModal.vue";

declare global {
  interface Window {
    dataLayer: any[];
  }
}
export default defineComponent({
  components: {
    DecoinsLimitModal,
    Loading,
    moldure: Moldure,
    ErrorBox,
    SuccessBox,
    AlertBox,
    IndicationUsersModal
  },
  setup() {
    const store = useStore();

    /** Referência para o modal atual do list picker. */
    const currentListPickerModal: Ref<string> = ref("EmptyModal");

    onBeforeMount(async () => {
      if (isCirculoTemplate()) {
        createGoogleAnalyticsScript();
      }
      createClarityScript();

    });

    store.subscribe(mutation => {
      if (mutation.type === "list_picker_module/SET_VISIBILITY") {
        const modal: string = store.getters["list_picker_module/modal"];
        const isOpen: boolean = store.getters["list_picker_module/isOpen"];

        if (isOpen) {
          switch (modal) {
            case "IndicationUsersModal":
              currentListPickerModal.value = "IndicationUsersModal";
          }
        } else {
          currentListPickerModal.value = "EmptyModal";
        }
      }
    });

    const error = computed(() => store.getters["miscellany_module/error"]);
    const success = computed(() => store.getters["miscellany_module/success"]);
    const isLoading = computed(() => store.getters["utils_module/isLoading"]);
    const loadingMessage = computed(
      () => store.getters["utils_module/message"]
    );
    const isAlertBoxOpen = computed(
      () => store.getters["alert_box_module/isOpen"]
    );
    const isVisibleDecoinsModalLimit = computed(
      () => store.getters["decoins_module/isVisibleDecoinsModalLimit"]
    );

    /** Google tag (gtag.js) */
    const createGoogleAnalyticsScript = (): void => {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-GE17HZWX5N";
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];

      const gtag = (...args: any[]): void => {
        window.dataLayer.push(args);
      };

      gtag("js", new Date());
      gtag("config", "G-GE17HZWX5N");
    };

    return {
      error,
      isLoading,
      success,
      loadingMessage,
      isAlertBoxOpen,
      isVisibleDecoinsModalLimit,
      currentListPickerModal
    };
  }
});
